import type { EatonDspFileResult, EatonDspSummary } from './types';

export function mergeEatonResults(
  current: EatonDspFileResult[],
  incoming: EatonDspFileResult[],
): EatonDspFileResult[] {
  const byName = new Map(current.map((result) => [result.fileName, result]));
  for (const result of incoming) {
    byName.set(result.fileName, result);
  }
  return [...byName.values()];
}

export function summarizeEatonResults(
  results: readonly EatonDspFileResult[],
): EatonDspSummary {
  const extracted = results.filter((result) => result.status === 'extracted');
  const prices = extracted.flatMap((result) => result.prices);
  const coverage = extracted.flatMap((result) => result.coverage);
  const duplicates = extracted.flatMap((result) => result.duplicates);
  const missingSpas = extracted.flatMap((result) => result.missingSpas);
  return {
    fileCount: results.length,
    extractedCount: extracted.length,
    unrecognizedCount: results.filter(
      (result) => result.status === 'unrecognized',
    ).length,
    unreadableCount: results.filter((result) => result.status === 'unreadable')
      .length,
    spaCount: new Set(prices.map((row) => row.spaId)).size,
    priceCount: prices.length,
    duplicateCount: duplicates.length,
    missingSpaCount: missingSpas.length,
    prices,
    coverage,
    duplicates,
    missingSpas,
  };
}
